export default { sha: 'a88d8777f84a969028d8e9b79fbdc74902ebd7c4', buildNumber: 'undefined' }
